import styled from 'styled-components';
import { tokens } from '../../../design/tokens';

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid ${tokens.color.railGraphite};

  flex-wrap: wrap;
`;

export const Titles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Title = styled.h1`
  color: ${tokens.color.textWhite};
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
`;

export const Subtitle = styled.p`
  color: ${tokens.color.textAsh};
  font-size: ${tokens.font.caption.size};
  margin: 0;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
